const TABLE_KEY = {
  FEEDBACK_TABLE_KEY: 'feedback',
};

export default TABLE_KEY;
